// removed by extract-text-webpack-plugin
module.exports = {"container":"ListViewLayout-container","content":"ListViewLayout-content"};